module.exports = __webpack_public_path__ + "img/2.65a56443.jpg";